<template>
    <Transition name="fade">
        <div v-if="isOpen" class="overlay-backdrop" @click.self="close">
            <div class="overlay-container">
                <header class="overlay-header">
                    <h3>{{ title }}</h3>
                    <button class="overlay-close" @click="close" aria-label="Schließen">
                        <BaseIcon name="ri-close-line" />
                    </button>
                </header>
                <div class="overlay-content">
                    <div class="share-dialog">
                        <div class="share-dialog__links">
                            <a :href="facebookUrl" target="_blank" class="share-dialog__link">
                                <BaseIcon name="ri-facebook-box-fill" />
                                <span>Facebook</span>
                            </a>
                            <a :href="whatsappUrl" target="_blank" class="share-dialog__link">
                                <BaseIcon name="ri-whatsapp-line" />
                                <span>WhatsApp</span>
                            </a>
                            <a :href="mailToUrl" class="share-dialog__link">
                                <BaseIcon name="ri-mail-line" />
                                <span>E-Mail</span>
                            </a>
                            <a v-if="canShareNative" href="#" @click.prevent="handleNativeShare"
                               class="share-dialog__link js-native-share">
                                <BaseIcon name="ri-share-forward-line" />
                                <span>Mehr</span>
                            </a>
                        </div>
                        <div class="share-dialog__copy">
                            <input type="text" :value="shareData.url" readonly ref="urlInput">
                            <button
                                class="button-primary form__button"
                                type="submit"
                                @click="copyToClipboard"
                            >
                                <span class="button-primary__icon">
                                    <BaseIcon name="ri-checkbox-circle-line" v-if="isCopied" />
                                    <BaseIcon name="ri-clipboard-line" v-else />
                                </span>
                                <span class="button-primary__label">
                                    {{ isCopied ? 'Kopiert!' : 'Kopieren' }}
                                </span>

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import BaseIcon from "../component/BaseIcon.vue";
import {ref, computed, onMounted, onUnmounted} from 'vue';
import {ShareService} from '../service/ShareService';

const isOpen = ref(false);
const isCopied = ref(false);
const title = ref('Seite teilen');
const shareData = ref({
    title: '',
    text: '',
    url: window.location.href
});

const urlInput = ref(null);

const encodedUrl = computed(() => encodeURIComponent(shareData.value.url));
const encodedText = computed(() => encodeURIComponent(shareData.value.text));
const encodedTitle = computed(() => encodeURIComponent(shareData.value.title));

const facebookUrl = computed(() => `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl.value}`);
const whatsappUrl = computed(() => `https://wa.me/?text=${encodedText.value}%20${encodedUrl.value}`);
const mailToUrl = computed(() => `mailto:?subject=${encodedTitle.value}&body=${encodedText.value}%20${encodedUrl.value}`);

const canShareNative = computed(() => typeof navigator.share !== 'undefined');

const open = (data) => {
    if (data) {
        shareData.value = {
            title: data.title || '',
            text: data.text || '',
            url: data.url || window.location.href
        };
    }
    isOpen.value = true;
    document.body.classList.add('overlay-open');
};

const close = () => {
    isOpen.value = false;
    document.body.classList.remove('overlay-open');
};

const handleNativeShare = () => {
    if (navigator.share) {
        navigator.share(shareData.value).catch(error => {
            console.error('Error sharing:', error);
        });
    }
};

const copyToClipboard = () => {
    if (urlInput.value) {
        urlInput.value.select();
        document.execCommand('copy');
        showCopiedAnimation();
    }
};

const showCopiedAnimation = () => {
    isCopied.value = true;
    setTimeout(() => {
        isCopied.value = false;
    }, 3000)
}

const handleKeydown = (e) => {
    if (e.key === 'Escape' && isOpen.value) {
        close();
    }
};

onMounted(() => {
    ShareService.on('open', open);
    ShareService.on('close', close);
    window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
    ShareService.off('open', open);
    ShareService.off('close', close);
    window.removeEventListener('keydown', handleKeydown);
});
</script>
